<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 offset-sm1 md10 offset-md1
    lg8 offset-lg2 xl6 offset-xl3 class="mb-3 mx-0" align-center>
      <slot></slot>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'mv-med-row'
}
</script>
